import type { ReactNode } from 'react';
import { AuthStateProvider } from '@/lib/auth-state';

interface ProvidersProps {
  children: ReactNode;
}

export function AuthProviders({ children }: ProvidersProps) {
  return <AuthStateProvider>{children}</AuthStateProvider>;
}
